import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import { Grid } from "@mui/material";
import IconGroupHeader from "@icoach/nonMember/components/IconGroupHeader";
import { NON_MEMBER_ROUTER } from "@icoach/router/routerPath";
import { Typography, Button, TextField, Stack, SelectField, MenuItem, Chip, Box } from "@curves/ui-base";
import { SourceTypeSelectField } from "@icoach/components/mutipleSelectField/";
import { refIsRequiredError } from "@util/utils";
import useCustomerApi from "@apis/useCustomerApi";

const CustomerBasicInformationBox = props => {
	const { sourceData = {} } = props;
	const { cellPhone, customerID, customerName, requiredType, introducer, askRecordType = "", notes, sourceType, sourceTag, employeeID, isValid, resource = {} } = sourceData;

	const { putCustomersInfoApi } = useCustomerApi();
	const history = useHistory();
	const nameRef = useRef(null);
	const phoneRef = useRef(null);
	const sourceTypeSelectorRef = useRef(null);
	const needsRef = useRef(null);
	const employeeRef = useRef(null);
	const askRecordTypeRef = useRef(null);
	const introducerRef = useRef(null);
	const noteRef = useRef(null);

	const handleBackToOverviewClick = e => redirectCustomerOverview();

	const handleUpdateClick = e => {
		if (!refIsRequiredError(nameRef, phoneRef, sourceTypeSelectorRef, needsRef, introducerRef, noteRef)) {
			let sourceTypeData = sourceTypeSelectorRef.current.getResult();
			const params = {
				...sourceTypeData,
				name: nameRef.current.getResult(),
				cellPhone: phoneRef.current.getResult(),
				requiredType: needsRef.current.getResult(),
				askRecordType: askRecordTypeRef.current.getResult() || 0,
				introducer: introducerRef.current.getResult(),
				notes: noteRef.current.getResult(),
				employeeID: employeeRef.current.getResult(),
			};
			doModifyApi(params);
		}
	};

	const redirectCustomerOverview = () => history.push(NON_MEMBER_ROUTER.CUSTOMER.OVERVIEW);

	const doModifyApi = async params => {
		const resp = await putCustomersInfoApi(customerID, params);
		if (resp) redirectCustomerOverview();
	};

	const { coachOptions = [], sourceTypes = [], requiredTypes = [], askRecordTypes = [] } = resource;

	return (
		<React.Fragment>
			<Stack alignItems="center" justifyContent="space-between">
				<Stack alignItems="center">
					<Typography variant="h5">顧客資料</Typography>
					<Chip className="ml-3" label={isValid ? "有效" : "無效"} color={isValid ? "success" : "warning"} />
				</Stack>
				<Box>
					<IconGroupHeader
						viewIconArray={["appointment", "contact", isValid ? "invalid" : "", "remove"]}
						rowsData={[{ ...sourceData, displayTypeText: "顧客" }]}
						peopleID={customerID}
						urls={{
							apo: NON_MEMBER_ROUTER.CUSTOMER.GET_ADD_PATH(customerID),
						}}
					/>
				</Box>
			</Stack>
			<Grid container spacing={3}>
				<Grid item xs={6}>
					<TextField ref={nameRef} label="姓名" defaultValue={customerName} required fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField ref={phoneRef} label="手機" defaultValue={cellPhone} maskType={"MOB"} required fullWidth />
				</Grid>
				<SourceTypeSelectField ref={sourceTypeSelectorRef} options={sourceTypes} defaultSourceType={sourceType} defaultSourceTag={sourceTag} gridSize={12} />
				<Grid item xs={6}>
					<SelectField ref={needsRef} label="需求" displayEmpty defaultValue={requiredType} required fullWidth>
						<MenuItem disabled value="">
							<em>請選擇</em>
						</MenuItem>
						{requiredTypes.map(({ text, value, disabled }) => (
							<MenuItem value={value} key={text} disabled={disabled}>
								{text}
							</MenuItem>
						))}
					</SelectField>
				</Grid>
				<Grid item xs={6}>
					<SelectField ref={askRecordTypeRef} label="詢問狀態" displayEmpty defaultValue={askRecordType} required fullWidth>
						<MenuItem disabled value="">
							<em>請選擇</em>
						</MenuItem>
						{askRecordTypes.map(({ text, value, disabled }) => (
							<MenuItem value={value} key={text} disabled={disabled}>
								{text}
							</MenuItem>
						))}
					</SelectField>
				</Grid>
				<Grid item xs={6}>
					<TextField label="介紹人" defaultValue={introducer} ref={introducerRef} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<SelectField ref={employeeRef} label="擔當" displayEmpty defaultValue={employeeID} required fullWidth>
						<MenuItem disabled value="">
							<em>請選擇</em>
						</MenuItem>
						{coachOptions.map(({ text, value, disabled }) => (
							<MenuItem value={value} key={text} disabled={disabled}>
								{text}
							</MenuItem>
						))}
					</SelectField>
				</Grid>
				<Grid item xs={12}>
					<TextField label="備註" defaultValue={notes} ref={noteRef} rows={4} fullWidth multiline />
				</Grid>
			</Grid>
			<Stack justifyContent="end" spacing={2} className="mt-4">
				<Button variant="outlined" color="secondary" width={15} onClick={handleBackToOverviewClick}>
					返回顧客清單
				</Button>
				<Button variant="contained" color="secondary" width={15} onClick={handleUpdateClick}>
					更新資料
				</Button>
			</Stack>
		</React.Fragment>
	);
};

export default CustomerBasicInformationBox;
